// Models
import { Job } from "./job.model";

export class HistoricalQueueDto {
	id: number;
	fromJobId: number;
	dateStarted: Date;
	dateEnded: Date;
	toJobId: Date;
	historicalQueueStatusId: number;
	createdDate: Date;
	executionStartDate?: Date;
	executionEndDate?: Date;
	createdByUserId?: number;
	fromJob?: Job;
	toJob?: Job;
	historicalQueueStatus: HistoricalQueueStatus;
}

export enum HistoricalQueueStatus {
	PendingAutoProcessing = 1,
	PendingSplitProcessing = 2,
	PendingMergeProcessing = 3,
	ProcessCompleteSplit = 4,
	ProcessCompleteMerged = 5,
	ProcessFailed = 6
}
